export const SITE = {
  name: "RM. Payakumbuah",
  longName: "Nasi Padang Payakumbuah",
  tagline: "#YoSabanaLamak",
  domain: "https://nasipadangpayakumbuah.com",
  company: "PT. Makan Padang Pakai Tangan",
  address:
    "Jl. Islamic 2 No.3, Kelapa Dua, Karawaci, Kabupaten Tangerang, Banten 15810",
  wa: {
    label: "+62 818-0205-5888",
    href: "https://wa.me/6281802055888",
    note: "Kritik & Saran",
  },
  waPartner: {
    label: "+62 813-1941-7990",
    href: "https://wa.me/6281319417990",
    note: "Partnership & Kemitraan",
  },
  instagram: "https://www.instagram.com/padangpayakumbuah/",
  facebook: "https://web.facebook.com/profile.php?id=100088000674574",
  linkedin: "https://www.linkedin.com/company/pt-rasa-muda-makmur",
  gofood:
    "https://gojek.link/gofood/merchant/category/MERCHANTS_RM_PAYAKUMBUAH",
  maps: "https://www.google.com/maps/d/viewer?mid=1Z0qqlv1sxB5qWHiTnbk-5JmWWYarHCc",
  official: "https://www.payakumbuah.co.id/",
};

export const DISHES = [
  {
    name: "Rendang",
    desc: "Daging sapi yang dimasak perlahan dalam santan dan rempah hingga kering, pekat, dan meresap — ikon masakan Minang yang mendunia.",
    img: "/images/rendang.jpg",
    w: 1280,
    h: 857,
    alt: "Rendang daging sapi asli Padang dengan bumbu pekat",
  },
  {
    name: "Dendeng Batokok Lado Merah",
    desc: "Irisan daging sapi tipis yang diketuk hingga empuk, digoreng garing, lalu disiram cabai merah giling yang hangat dan menggigit.",
    img: "/images/dendeng.jpg",
    w: 1280,
    h: 960,
    alt: "Dendeng sapi goreng dengan sambal lado merah khas Minang",
  },
  {
    name: "Ayam Pop",
    desc: "Ayam kampung yang direbus dengan bumbu lembut hingga putih dan gurih, disajikan dengan sambal khas — favorit lintas generasi.",
    img: "/images/ayam-pop.jpg",
    w: 1280,
    h: 960,
    alt: "Ayam pop khas rumah makan Padang",
  },
  {
    name: "Teh Talua",
    desc: "Teh telur khas Sumatera Barat — teh hangat yang dikocok bersama kuning telur hingga berbusa lembut, manis, dan beraroma wangi.",
    img: "/images/teh-talua.jpg",
    w: 1280,
    h: 1660,
    alt: "Teh talua, teh telur khas Sumatera Barat",
  },
  {
    name: "Es Durian",
    desc: "Kesegaran durian dalam sajian dingin — penutup yang pas setelah menikmati hidangan bersantan dan bercabai.",
    img: "/images/es-durian.jpg",
    w: 1280,
    h: 2064,
    alt: "Es durian segar khas Sumatera",
  },
];

export const MORE_MENU = [
  "Ikan Salai",
  "Telur Barendo",
  "Nasi Bungkus",
  "Nasi Box",
];

export const OUTLETS = [
  { name: "Restaurant Payakumbuah Kemang", city: "Jakarta Selatan" },
  { name: "Restaurant Payakumbuah Menteng", city: "Jakarta Pusat" },
  { name: "RM Payakumbuah Tebet", city: "Jakarta Selatan" },
  { name: "RM Payakumbuah Veteran", city: "Jakarta Selatan" },
  { name: "RM Payakumbuah Cibubur", city: "Jakarta Timur" },
  { name: "Restaurant Payakumbuah Gading Serpong", city: "Tangerang" },
  { name: "RM Payakumbuah Ciater", city: "BSD, Tangerang Selatan" },
  { name: "RM Payakumbuah Depok", city: "Depok" },
  { name: "RM Payakumbuah Bogor", city: "Bogor" },
  { name: "RM Payakumbuah Bekasi", city: "Bekasi" },
  { name: "RM Payakumbuah Bandung", city: "Bandung" },
  { name: "RM Payakumbuah Semarang", city: "Semarang" },
];

export const FAQS = [
  {
    q: "Apa itu RM. Payakumbuah?",
    a: "RM. Payakumbuah adalah rumah makan masakan Minang yang digagas oleh Arief Muhammad dan diresmikan pada 24 Juli 2022. Dapur kami menjaga cita rasa otentik masakan Minangkabau, antara lain dengan menggunakan beras Solok dari Sumatera Barat. Tagline kami: #YoSabanaLamak.",
  },
  {
    q: "Di mana saja outlet RM. Payakumbuah?",
    a: "Outlet kami tersebar di Jakarta (Kemang, Menteng, Tebet, Veteran, Cibubur), Tangerang Raya (Gading Serpong, Ciater BSD), Depok, Bogor, Bekasi, Bandung, dan Semarang. Daftar lengkap dan peta resmi dapat dilihat di halaman Lokasi.",
  },
  {
    q: "Bagaimana cara memesan secara online?",
    a: "RM. Payakumbuah tersedia di GoFood. Pilih outlet terdekat dari tautan GoFood resmi kami, lalu pesan hidangan favorit Anda untuk diantar.",
  },
  {
    q: "Apakah melayani nasi box dan catering untuk acara?",
    a: "Ya. Kami melayani pemesanan nasi box serta catering untuk berbagai acara. Silakan hubungi WhatsApp resmi kami untuk ketersediaan, pilihan paket, dan pemesanan.",
  },
  {
    q: "Berapa harga menu di RM. Payakumbuah?",
    a: "Harga dapat berbeda di tiap outlet dan kanal pemesanan. Untuk daftar menu dan harga terkini, silakan hubungi WhatsApp resmi kami atau lihat langsung di aplikasi GoFood pada outlet pilihan Anda.",
  },
  {
    q: "Jam berapa RM. Payakumbuah buka?",
    a: "Jam operasional berbeda di setiap outlet. Silakan cek jam buka outlet terdekat melalui aplikasi GoFood atau tanyakan langsung melalui WhatsApp resmi kami.",
  },
];
